import React from "react";
import GapButton from "../gap-button/GapButton";
import ListItem from "../list-item/ListItem";
import List from "../list/List";

const ContractList = ({ contractListData, selectedContractDisplay, contractsLength, handleBack }) => {

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [month, day, year].join('/');

    }

    const viewContract = (data) => {
        selectedContractDisplay(data);
    }

    const displayData = () => {

        return contractListData.map((item, i) => {
            return (
                <div className="card mt-9" key={i}>
                    <div className="card-container">
                        <div className="d-flex align-items-center justify-content-between mt-9">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-file-contract card-title__icon" />
                                <div className="card-title">Contract Information</div>
                            </div>
                            <GapButton
                                buttonType="button"
                                id={item.number}
                                buttonLabel="View"
                                buttonClass="next-btn cursor-pointer"
                                onClick={() => { viewContract(item); }}
                            />
                        </div>
                        <div key={i} className={"d-flex pl-31 flex-wrap flex-row"}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Contract Number" itemValue={item.number} />
                                </div>
                                <div className="card-col__1 mt-11 d-flex">
                                    <div className="w-100">
                                        <ListItem itemKey="Policy Type" itemValue={item.type} />
                                    </div>
                                    <div className="w-100">
                                        <ListItem itemKey="Status" itemValue={item.status} />
                                    </div>
                                </div>
                                <div className="card-col__1 mt-11 d-flex">
                                    <div className="w-100">
                                        <ListItem itemKey="Effective Date" itemValue={formatDate(item.saleDate)} />
                                    </div>
                                    <div className="w-100">
                                        <ListItem itemKey="Expiration Date" itemValue={formatDate(item.expirationDate)} />
                                    </div>
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Contract Holder" itemValue={item.customer.name} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="VIN" itemValue={item.vehicle.vin} />
                                </div>
                            </List>
                        </div>

                    </div>
                </div>
            )
        })
    }
    return (
        <React.Fragment>
            <h4 className="contract-title">Contracts Found</h4>
            <p className="contract-description">
                We found {contractsLength} matching Contracts.
            </p>
            <div className="contract-list-container">
                {displayData()}
                <div className="mt-20 stepper-btn" id="stepperBtn">
                    <GapButton
                        onClick={() => { handleBack(); }}
                        id="multiple-contracts-back-button"
                        buttonType="button"
                        buttonClass="contracts-back-button"
                        buttonLabel="Back" />
                </div>
            </div>
        </React.Fragment>
    )
};

export default ContractList;